import request from "~/utils/http";
import requestv2 from "~/utils/http-v2";

const uploadWebsiteApi = {
	gets : async (params) => {
		const url = 'v2/upload-website';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/upload-website';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/upload-website/${params.id}`;
		return await requestv2.patch(url, params);
	},
	deadline : async (params) => {
		const url = `v2/upload-website/deadline/${params.id}`;
		return await requestv2.post(url, params);
	},
	host : async (params) => {
		const url = `v2/upload-website/host/${params.id}`;
		return await requestv2.post(url, params);
	},
	uploadToHost : async (params) => {
		const url = `v2/upload-website/upload-to-host/${params.id}`;
		return await requestv2.post(url, params);
	},
	loginHost : async (id) => {
		const url = `v2/upload-website/login-host/${id}`;
		return await requestv2.post(url);
	},
	source : async (params) => {
		const url = `v2/upload-website/source`;
		return await requestv2.post(url, params);
	},
	status : async (params) => {
		const url = `v2/upload-website/status/${params.id}`;
		return await requestv2.post(url, params);
	},
	addHost : async (params) => {
		const url = `v2/upload-website/add-host/${params.id}`;
		return await requestv2.post(url, params);
	},
	delete : async (id) => {
		const url = `v2/upload-website/${id}`;
		return await requestv2.delete(url);
	}
};

export default uploadWebsiteApi;